/*
 * @Description: axios 封装网络请求
 */

import { useStore } from '@/store'
import axios from 'axios'
// import qs from 'qs'
// import setting from '@/config/default/setting.config'
import HttpClient, { HttpClientConfig, ContentType } from 'axios-mapper'
import networkConfig from '@/config/default/net.config'
// import { sign } from '@/utils/ase'
import { ElMessage } from 'element-plus'

const https = () => {
  const config: HttpClientConfig = {
    baseURL: networkConfig.host,
    headers: {}
  }
  const httpClient = new HttpClient(config)
  httpClient.httpClient.interceptors.request.use((config) => {
    /* // 参数签名处理
    config = sign(config, setting.appId, setting.appSecret, 'SHA256')
    config.method === 'get'
      ? config.params = { ...config.params } : config.data = qs.stringify({ ...config.data })
    */
    const token = useStore().state.user.token
    if (token) {
      config.headers.Authorization = 'Bearer ' + token
    }
    // console.log(config)
    return config
  })

  httpClient.httpClient.interceptors.response.use((response) => {
    if (response.data.code === 0) {
      // 服务端定义的响应code码为0时请求成功
      // 使用Promise.resolve 正常响应
      return Promise.resolve(response)
    } else {
      // 使用Promise.reject 响应
      ElMessage({
        message: response.data.message,
        type: 'error',
        duration: 2000
      })
      return Promise.reject(response)
    }
  }, error => {
    let message = ''
    if (error && error.response) {
      switch (error.response.status) {
        case 401:
          location.reload()
          return
        case 403:
          message = error.response.data.path + ',' + error.response.data.message
          break
        case 429:
          message = '访问太过频繁，请稍后再试!'
          break
        default:
          message = error.response.data.message ? error.response.data.message : '服务器错误'
          break
      }
      ElMessage({
        message: message,
        type: 'error',
        duration: 2000
      })
      // 请求错误处理
      return Promise.reject(error)
    } else {
      message = '连接服务器失败'
      ElMessage({
        message: message,
        type: 'error',
        duration: 2000
      })
      return Promise.reject(error)
    }
  })
  return httpClient
}

export default https

export const axiosHttpPost = (url: string, data: any, contentType: ContentType) => {
  return axios.post(networkConfig.host?.concat(url) ?? '', data, { headers: { 'Content-type': contentType, Authorization: 'Bearer ' + useStore().state.user.token } })
}
